const PINK = '#E60A86';
const PINK_DEEP = '#B8086A';

/** Sport accent gradient pair for workout chrome headers. */
export function sportGradient(englishName?: string | null): [string, string] {
  const s = (englishName ?? '').toLowerCase();
  if (s.includes('run')) return ['#FF8A65', '#E55427'];
  if (s.includes('swim')) return ['#29C8D4', '#1A9BA5'];
  if (s.includes('strength') || s.includes('gym')) return ['#A78BFA', '#6366F1'];
  return [PINK, PINK_DEEP];
}
